import { Player } from "@prisma/client";

export const SEASON = 2024;
export const DEFAULT_SEASON = SEASON;
export const CURRENT_SEASONS = [2024, 2025];
export const USA = "USA";

export const LEAGUE_IDS = {
  ENGLISH_PREMIER_LEAGUE: 39,
  ENGLISH_CHAMPIONSHIP: 40,
  ENGLISH_FA_CUP: 45,
  SCOTTISH_PREMIERSHIP: 179,
  SCOTTISH_CHAMPIONSHIP: 180,
  COPPA_ITALIA: 137,
  SERIE_A: 135,
  SERIE_B: 136,
  BELGIAN_PRO_LEAGUE: 144,
  MLS: 253,
  LA_LIGA: 140,
  COPA_DEL_REY: 143,
  BUNDESLIGA: 78,
  GERMAN_DFB_POKAL: 81,
  DUTCH_LEAGUE_1: 88,
  DUTCH_LEAGUE_2: 89,
  FRENCH_LIGUE_1: 61,
  FRENCH_LEAGUE_CUP: 526,
  COUPE_DE_FRANCE: 66,
  CHAMPIONS_LEAGUE: 2,
  EUROPA_LEAGUE: 3,
  UEFA_EUROPA_CONFERENCE_LEAGUE: 848,
  PREMEIRA_LIGA: 94,
  LIGA_MX: 262,
  DENMARK_SUPERLIGA: 119,
  // second div spain
  // second div france
  // second div germany
  // turkish first
  // greek first
};

export const NATIONAL_CUPS = [
  LEAGUE_IDS.ENGLISH_FA_CUP,
  LEAGUE_IDS.COPPA_ITALIA,
  LEAGUE_IDS.COPA_DEL_REY,
  LEAGUE_IDS.GERMAN_DFB_POKAL,
  LEAGUE_IDS.FRENCH_LEAGUE_CUP,
  LEAGUE_IDS.COUPE_DE_FRANCE,
];

export const EURO_LEAGUES = [
  LEAGUE_IDS.CHAMPIONS_LEAGUE,
  LEAGUE_IDS.EUROPA_LEAGUE,
  LEAGUE_IDS.UEFA_EUROPA_CONFERENCE_LEAGUE,
];

export const LEAGUE_SEASON_OVERRIDES = {
  [LEAGUE_IDS.MLS]: 2025,
};

export function getLeagueSeason(leagueId: number): number {
  return LEAGUE_SEASON_OVERRIDES[leagueId] || SEASON;
}

export const NATIONAL_TEAM_IDS = {
  USA: 2384,
  USA_U23: 17883,
  USA_U20: 10306,
};

// Sync this players by default
export const CUSTOM_PLAYER_IDS = [
  462853, // Cavan Sullivan
  359603, // Luca Koleosho - Italian
  361981, // Arnie Chase - Japanese
  280074, // Nathaniel Brown
  407652, // Patrick Agyemang
  312896, // Diego Luna
  362400, // Maximilian Arfsten
];

export const CUSTOM_PLAYER_OVERRIDES: { [key: number]: Partial<Player> } = {
  407652: {
    nationality: "USA",
    birth_country: "USA",
  },
};

export const LEAGUES_BY_ID = reverseMap(LEAGUE_IDS);

function reverseMap(map: Record<string, number>): Record<number, string> {
  const reversedMap: Record<number, string> = {};

  for (const [key, value] of Object.entries(map)) {
    reversedMap[value] = key;
  }

  return reversedMap;
}

export const MATCH_FINISHED_STATUS = ["FT", "AET", "PEN"];

export const YOUTH_TEAM_REGEX = /U21|U23|Jong/;
